'use strict';
import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import AccessManagementContainer from './accessManagement/AccessManagementContainer.jsx';
import { NavBar, NavButton } from '../../components/index.jsx';
import ManagementPageCard from '../../components/layout/ManagementPageCard.jsx';
import urljoin from 'url-join';

export class AccessManagementPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	/** Render Router components, ignoring routes */
	renderAccessManagement = /* istanbul ignore next */ () => <AccessManagementContainer history={this.props.history} />;

	render() {
		const { match } = this.props;
		return (
			<ManagementPageCard
				className="app-content"
				header={(
					<NavBar history={this.props.history} controlled={true} size="small">
						<NavButton to={urljoin(match.url, '/usermanagement')}>
							<span style={{ fontSize: '1.125rem', fontWeight: 500 }}>Access Management</span>
						</NavButton>
					</NavBar>
				)}
			>
				<div className="main">
					<Switch>
						<Route path={match.url + '/'} render={this.renderAccessManagement} />
					</Switch>
				</div>
			</ManagementPageCard>
		);
	}
}

export default withRouter(AccessManagementPage);
